<template>
  <div class="lc">
    <button class="lc__fab" aria-label="Abrir Lau IA" @click="abrirChat">
      <span class="lc__fab-ring lc__fab-ring--1"></span>
      <span class="lc__fab-ring lc__fab-ring--2"></span>
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="13" r="2" fill="currentColor"/>
        <circle cx="21" cy="13" r="2" fill="currentColor"/>
        <path d="M8 20c1.5 2.5 4 4 8 4s6.5-1.5 8-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M4 16C4 9.373 9.373 4 16 4s12 5.373 12 12-5.373 12-12 12H5l-1-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <Teleport to="body">
      <Transition name="lc-dialog">
        <div v-if="dialogAberto" class="lc__overlay" @click.self="dialogAberto = false">
          <div class="lc__panel" :class="{ 'lc__panel--fullscreen': isMobile }">

            <!-- Header -->
            <div class="lc__header">
              <div class="lc__header-left">
                <div class="lc__avatar">
                  <svg viewBox="0 0 32 32" fill="none">
                    <circle cx="11" cy="13" r="2" fill="currentColor"/>
                    <circle cx="21" cy="13" r="2" fill="currentColor"/>
                    <path d="M8 20c1.5 2.5 4 4 8 4s6.5-1.5 8-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <path d="M4 16C4 9.373 9.373 4 16 4s12 5.373 12 12-5.373 12-12 12H5l-1-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div>
                  <div class="lc__header-name">Lau IA</div>
                  <div class="lc__header-status">
                    <span class="lc__status-dot"></span>
                    {{ enviandoMensagem ? 'Pensando...' : 'Assistente de estudos' }}
                  </div>
                </div>
              </div>

              <div class="lc__header-actions">
                <div class="lc__sessions-wrap">
                  <button class="lc__icon-btn" title="Conversas" @click="sessoesAbertas = !sessoesAbertas">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  </button>
                  <Transition name="lc-drop">
                    <div v-if="sessoesAbertas" class="lc__sessions-dropdown" @click.stop>
                      <button class="lc__session-new" @click="criarNovaSessao(); sessoesAbertas = false">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                        Nova conversa
                      </button>
                      <div v-if="sessoes.length" class="lc__sessions-list">
                        <button
                            v-for="s in sessoes" :key="s.id"
                            class="lc__session-item"
                            :class="{ 'lc__session-item--active': sessaoAtual && sessaoAtual.id === s.id }"
                            @click="selecionarSessao(s); sessoesAbertas = false"
                        >
                          <span class="lc__session-title">{{ obterTituloSessao(s) }}</span>
                          <span class="lc__session-date">{{ formatarData(s.updatedAt || s.createdAt) }}</span>
                        </button>
                      </div>
                    </div>
                  </Transition>
                </div>
                <button class="lc__icon-btn" title="Fechar" @click="dialogAberto = false">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </div>

            <!-- Body -->
            <div ref="chatBody" class="lc__body">
              <div v-if="erro" class="lc__error">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {{ erro }}
              </div>

              <div v-if="carregandoMensagens" class="lc__state">
                <div class="lc__spinner"><span></span><span></span><span></span></div>
              </div>

              <div v-else-if="mensagens.length === 0" class="lc__empty">
                <div class="lc__empty-icon">
                  <svg viewBox="0 0 48 48" fill="none">
                    <circle cx="17" cy="20" r="3" fill="currentColor"/>
                    <circle cx="31" cy="20" r="3" fill="currentColor"/>
                    <path d="M12 30c2.5 4 6 6 12 6s9.5-2 12-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
                    <path d="M6 24C6 14.059 14.059 6 24 6s18 8.059 18 18-8.059 18-18 18H8l-2-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <p class="lc__empty-title">Pergunte para a Lau IA</p>
                <p class="lc__empty-sub">Tire dúvidas de estudo com base no material jurídico.</p>
                <div class="lc__chips">
                  <button v-for="s in sugestoes" :key="s" class="lc__chip" @click="usarSugestao(s)">{{ s }}</button>
                </div>
              </div>

              <TransitionGroup v-else name="lc-msg" tag="div" class="lc__messages">
                <div
                    v-for="m in mensagens"
                    :key="m.localId || m.id"
                    class="lc__msg"
                    :class="m.role === 'USER' ? 'lc__msg--user' : 'lc__msg--ai'"
                >
                  <div v-if="m.role !== 'USER'" class="lc__msg-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none"/>
                      <circle cx="15" cy="10" r="1.5" fill="currentColor" stroke="none"/>
                      <path d="M6 15c1 2 3 3 6 3s5-1 6-3"/>
                      <path d="M3 12C3 7.029 7.029 3 12 3s9 4.029 9 9-4.029 9-9 9H4l-1-3"/>
                    </svg>
                  </div>

                  <div class="lc__bubble-wrap">
                    <div class="lc__bubble">
                      <template v-if="m.role === 'USER'">{{ m.content }}</template>
                      <template v-else>
                        <div
                            v-for="(bloco, i) in obterBlocosMensagem(m)"
                            :key="`${m.localId || m.id}-b-${i}`"
                            class="lc-block" :class="`lc-block--${bloco.type}`"
                        >
                          <div v-if="bloco.type === 'heading'" class="lc-block__heading">
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="8" cy="8" r="6"/><line x1="8" y1="5" x2="8" y2="8"/><circle cx="8" cy="11" r="0.5" fill="currentColor"/></svg>
                            {{ removerMarcadoresMarkdown(bloco.text) }}
                          </div>
                          <p v-else-if="bloco.type === 'paragraph'" class="lc-block__p">
                            <span v-for="(pt, j) in formatarTextoInline(bloco.text)" :key="`p-${i}-${j}`" :class="{ 'lc-b': pt.bold, 'lc-i': pt.italic }">{{ pt.text }}</span>
                          </p>
                          <div v-else-if="bloco.type === 'subheading'" class="lc-block__sub">{{ removerMarcadoresMarkdown(bloco.text) }}</div>
                          <blockquote v-else-if="bloco.type === 'quote'" class="lc-block__quote">
                            <span v-for="(pt, j) in formatarTextoInline(bloco.text)" :key="`q-${i}-${j}`" :class="{ 'lc-b': pt.bold, 'lc-i': pt.italic }">{{ pt.text }}</span>
                          </blockquote>
                          <div v-else-if="bloco.type === 'legal-item'" class="lc-block__legal">
                            <span class="lc-block__legal-marker">{{ bloco.marker }}</span>
                            <span><span v-for="(pt, j) in formatarTextoInline(bloco.text)" :key="`l-${i}-${j}`" :class="{ 'lc-b': pt.bold, 'lc-i': pt.italic }">{{ pt.text }}</span></span>
                          </div>
                          <ul v-else-if="bloco.type === 'list'" class="lc-block__list">
                            <li v-for="(item, k) in bloco.items" :key="`li-${i}-${k}`">
                              <span v-for="(pt, j) in formatarTextoInline(item)" :key="`li-t-${j}`" :class="{ 'lc-b': pt.bold, 'lc-i': pt.italic }">{{ pt.text }}</span>
                            </li>
                          </ul>
                          <div v-else-if="bloco.type === 'table'" class="lc-block__table-wrap">
                            <table class="lc-block__table">
                              <thead><tr><th v-for="(h, hi) in bloco.headers" :key="hi"><span v-for="(p,pi) in formatarTextoInline(h)" :key="pi" :class="{'lc-b':p.bold,'lc-i':p.italic}">{{p.text}}</span></th></tr></thead>
                              <tbody>
                              <tr v-for="(row, ri) in bloco.rows" :key="ri">
                                <td v-for="(cell, ci) in row" :key="ci">
                                  <div v-for="(ln, li) in quebrarLinhasCelula(cell)" :key="li"><span v-for="(p,pi) in formatarTextoInline(ln)" :key="pi" :class="{'lc-b':p.bold,'lc-i':p.italic}">{{p.text}}</span></div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div v-if="m.createdAt" class="lc__ts">{{ formatarDataHoraMensagem(m.createdAt) }}</div>

                    <div v-if="m.fundamentos && m.fundamentos.length" class="lc__fund">
                      <button class="lc__fund-toggle" @click="toggleFundamentos(m.localId || m.id)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
                        {{ m.fundamentos.length }} fundamento{{ m.fundamentos.length > 1 ? 's' : '' }}
                        <svg class="lc__chevron" :class="{ 'lc__chevron--open': fundamentosAbertos[m.localId || m.id] }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
                      </button>
                      <Transition name="lc-expand">
                        <div v-if="fundamentosAbertos[m.localId || m.id]" class="lc__fund-body">
                          <div v-for="(f, fi) in m.fundamentos" :key="fi" class="lc__fund-item">
                            <div class="lc__fund-title">{{ obterTituloFundamento(f) }}</div>
                            <div v-if="f.nomeLei || f.numeroArtigo" class="lc__fund-tags">
                              <span v-if="f.nomeLei" class="lc__tag">{{ formatarNomeLei(f.nomeLei) }}</span>
                              <span v-if="f.numeroArtigo" class="lc__tag">Art. {{ f.numeroArtigo }}</span>
                            </div>
                            <div v-if="f.trecho" class="lc__fund-trecho">{{ f.trecho }}</div>
                          </div>
                        </div>
                      </Transition>
                    </div>
                  </div>
                </div>
              </TransitionGroup>

              <Transition name="lc-msg">
                <div v-if="enviandoMensagem" class="lc__msg lc__msg--ai lc__msg--typing">
                  <div class="lc__msg-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none"/><circle cx="15" cy="10" r="1.5" fill="currentColor" stroke="none"/>
                      <path d="M6 15c1 2 3 3 6 3s5-1 6-3"/><path d="M3 12C3 7.029 7.029 3 12 3s9 4.029 9 9-4.029 9-9 9H4l-1-3"/>
                    </svg>
                  </div>
                  <div class="lc__bubble lc__bubble--typing">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              </Transition>
            </div>

            <!-- Composer -->
            <div class="lc__footer">
              <div class="lc__composer" :class="{ 'lc__composer--active': novaMensagem.length > 0 }">
                <textarea
                    ref="textareaRef"
                    v-model="novaMensagem"
                    class="lc__input"
                    placeholder="Digite sua pergunta..."
                    :disabled="enviandoMensagem"
                    maxlength="3000"
                    rows="1"
                    @keydown.enter.exact.prevent="enviarMensagem"
                    @input="ajustarTextarea"
                ></textarea>
                <button
                    class="lc__send"
                    :class="{ 'lc__send--ready': podeEnviar }"
                    :disabled="!podeEnviar"
                    title="Enviar"
                    @click="enviarMensagem"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                </button>
              </div>
            </div>

          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<script>
import iaChatRagService from '@/services/iaChatRagService';

export default {
  name: 'StudyAiChat',

  data() {
    return {
      dialogAberto: false,
      carregouInicial: false,
      carregandoSessoes: false,
      carregandoMensagens: false,
      enviandoMensagem: false,
      erro: null,
      sessoes: [],
      sessaoAtual: null,
      mensagens: [],
      novaMensagem: '',
      sessoesAbertas: false,
      fundamentosAbertos: {},
      sugestoes: [
        'O que é habeas corpus?',
        'Explique o princípio da legalidade',
        'Quais são os direitos fundamentais?',
      ],
    };
  },

  computed: {
    podeEnviar() {
      return this.novaMensagem.trim().length > 0 && !this.enviandoMensagem && !this.carregandoMensagens;
    },
    isMobile() {
      return window.innerWidth < 600;
    },
  },

  watch: {
    dialogAberto(val) {
      if (val) document.addEventListener('click', this.fecharSessoes);
      else { document.removeEventListener('click', this.fecharSessoes); this.sessoesAbertas = false; }
    },
  },

  beforeUnmount() {
    document.removeEventListener('click', this.fecharSessoes);
  },

  methods: {
    async abrirChat() {
      this.dialogAberto = true;
      if (!this.carregouInicial) await this.carregarSessoes();
      this.$nextTick(() => this.focarComposer());
    },

    async carregarSessoes() {
      this.carregandoSessoes = true;
      this.erro = null;
      try {
        const sessoes = await iaChatRagService.listarSessoes();
        this.sessoes = this.ordenarSessoes(sessoes || []);
        this.carregouInicial = true;
        if (!this.sessaoAtual && this.sessoes.length) await this.selecionarSessao(this.sessoes[0]);
      } catch { this.erro = 'Não foi possível carregar suas conversas.'; }
      finally { this.carregandoSessoes = false; }
    },

    async criarNovaSessao(titulo = 'Estudos') {
      this.carregandoSessoes = true;
      this.erro = null;
      try {
        const sessao = await iaChatRagService.criarSessao(titulo);
        this.sessoes = this.ordenarSessoes([sessao, ...this.sessoes.filter((s) => s.id !== sessao.id)]);
        this.sessaoAtual = sessao;
        this.mensagens = [];
      } catch { this.erro = 'Não foi possível iniciar uma nova conversa.'; throw new Error(); }
      finally { this.carregandoSessoes = false; }
    },

    async selecionarSessao(sessao) {
      if (!sessao || (this.sessaoAtual?.id === sessao.id && this.mensagens.length)) return;
      this.sessaoAtual = sessao;
      this.carregandoMensagens = true;
      this.erro = null;
      try {
        const msgs = await iaChatRagService.listarMensagens(sessao.id);
        this.mensagens = (msgs || []).map((m) => ({ ...m, localId: `api-${m.id}` }));
        this.rolarParaFim();
      } catch { this.erro = 'Não foi possível carregar as mensagens.'; }
      finally { this.carregandoMensagens = false; }
    },

    async enviarMensagem() {
      if (!this.podeEnviar) return;
      const texto = this.novaMensagem.trim();
      this.novaMensagem = '';
      this.erro = null;
      this.$nextTick(() => this.ajustarTextarea());
      try {
        if (!this.sessaoAtual) await this.criarNovaSessao(this.criarTituloDaMensagem(texto));
        this.mensagens.push({ localId: `user-${Date.now()}`, role: 'USER', content: texto, createdAt: new Date().toISOString() });
        this.enviandoMensagem = true;
        this.rolarParaFim();
        const resposta = await iaChatRagService.enviarMensagem(this.sessaoAtual.id, texto);
        this.mensagens.push({ localId: `ai-${Date.now()}`, role: 'ASSISTANT', content: resposta?.resposta || '', fundamentos: resposta?.fundamentos || [], createdAt: new Date().toISOString() });
        this.atualizarSessoesEmSegundoPlano();
        this.rolarParaFim();
      } catch { this.erro = 'Não foi possível enviar sua pergunta.'; this.novaMensagem = texto; }
      finally { this.enviandoMensagem = false; }
    },

    usarSugestao(s) { this.novaMensagem = s; this.enviarMensagem(); },
    fecharSessoes(e) { if (!e.target.closest('.lc__sessions-wrap')) this.sessoesAbertas = false; },
    toggleFundamentos(id) { this.fundamentosAbertos = { ...this.fundamentosAbertos, [id]: !this.fundamentosAbertos[id] }; },

    ajustarTextarea() {
      const el = this.$refs.textareaRef;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = Math.min(el.scrollHeight, 130) + 'px';
    },

    ordenarSessoes(s) { return [...s].sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0)); },
    obterTituloSessao(s) { return s?.titulo || 'Conversa de estudos'; },
    criarTituloDaMensagem(m) { return m.length > 48 ? `${m.slice(0, 45)}...` : m; },
    formatarData(d) { if (!d) return ''; return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(d)); },
    formatarDataHoraMensagem(d) { if (!d) return ''; return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(d)); },
    obterBlocosMensagem(m) { return m?.content ? this.criarBlocosResposta(m.content) : []; },

    criarBlocosResposta(content) {
      const linhas = String(content || '').replace(/\r\n/g, '\n').split('\n').map((l) => l.trimEnd());
      const blocos = []; let i = 0;
      while (i < linhas.length) {
        const linha = linhas[i].trim();
        if (!linha) { i++; continue; }
        if (/^\|.*\|$/.test(linha)) { const { bloco, proximoIndex } = this.criarBlocoTabela(linhas, i); if (bloco) blocos.push(bloco); i = proximoIndex; continue; }
        if (/^\*\*\d+\.\s+.+\*\*$/.test(linha)) { blocos.push({ type: 'heading', text: linha }); i++; continue; }
        if (/^\*[^*]+\*$/.test(linha)) { blocos.push({ type: 'subheading', text: linha }); i++; continue; }
        if (/^>\s?/.test(linha)) { const ps = []; while (i < linhas.length && /^>\s?/.test(linhas[i].trim())) { ps.push(linhas[i].trim().replace(/^>\s?/, '')); i++; } blocos.push({ type: 'quote', text: ps.join(' ') }); continue; }
        const ml = linha.match(/^((?:[IVXLCDM]+)\s*[–-]|[a-z]\)|§\s*\d+º?)\s*(.+)$/i);
        if (ml) { blocos.push({ type: 'legal-item', marker: ml[1].trim(), text: ml[2].trim() }); i++; continue; }
        if (/^[-*]\s+/.test(linha)) { const items = []; while (i < linhas.length && /^[-*]\s+/.test(linhas[i].trim())) { items.push(linhas[i].trim().replace(/^[-*]\s+/, '')); i++; } blocos.push({ type: 'list', items }); continue; }
        const ps = [];
        while (i < linhas.length && linhas[i].trim() && !/^\|.*\|$/.test(linhas[i].trim()) && !/^\*\*\d+\.\s+.+\*\*$/.test(linhas[i].trim())) { ps.push(linhas[i].trim()); i++; }
        blocos.push({ type: 'paragraph', text: ps.join(' ') });
      }
      return blocos;
    },

    criarBlocoTabela(linhas, startIndex) {
      const tl = []; let i = startIndex;
      while (i < linhas.length && /^\|.*\|$/.test(linhas[i].trim())) { tl.push(linhas[i].trim()); i++; }
      if (tl.length < 2) return { bloco: { type: 'paragraph', text: tl.join(' ') }, proximoIndex: i };
      const rows = tl.filter((l) => !/^\|[\s:|-]+\|$/.test(l)).map((l) => l.replace(/^\|/, '').replace(/\|$/, '').split('|').map((c) => c.trim()));
      return { bloco: { type: 'table', headers: rows.shift() || [], rows }, proximoIndex: i };
    },

    quebrarLinhasCelula(c) { return String(c || '').split(/<br\s*\/?>/i).map((l) => l.trim()).filter(Boolean); },

    formatarTextoInline(texto) {
      const partes = []; const re = /(\*\*(.*?)\*\*|\*(.*?)\*)/g; let last = 0, m;
      while ((m = re.exec(texto)) !== null) {
        if (m.index > last) partes.push({ text: texto.slice(last, m.index), bold: false, italic: false });
        partes.push({ text: m[2] || m[3], bold: Boolean(m[2]), italic: Boolean(m[3]) });
        last = re.lastIndex;
      }
      if (last < texto.length) partes.push({ text: texto.slice(last), bold: false, italic: false });
      return partes.length ? partes : [{ text: texto, bold: false, italic: false }];
    },

    removerMarcadoresMarkdown(t) { return t.replace(/^\*\*|\*\*$/g, '').replace(/^\*|\*$/g, ''); },
    obterTituloFundamento(f) { return f.titulo || this.formatarNomeLei(f.nomeLei) || f.norma || 'Fonte jurídica'; },
    formatarNomeLei(nome) {
      if (nome === 'CONSTITUICAO_FEDERAL') return 'Constituição Federal';
      return nome?.toLowerCase().split('_').map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(' ') || '';
    },
    async atualizarSessoesEmSegundoPlano() {
      try { this.sessoes = this.ordenarSessoes(await iaChatRagService.listarSessoes() || []); } catch { /* silent */ }
    },
    rolarParaFim() { this.$nextTick(() => { const el = this.$refs.chatBody; if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' }); }); },
    focarComposer() { const el = this.$refs.textareaRef; if (el) el.focus(); },
  },
};
</script>

<style scoped>
/* ─── Variables ─────────────────────────────────────────── */
.lc {
  --blue: #1976d2;
  --blue-dark: #1565c0;
  --blue-light: #42a5f5;
  --blue-bg: #e3f2fd;
  --blue-bg-soft: #f0f7ff;
  --blue-border: rgba(25, 118, 210, 0.14);
  --blue-border-mid: rgba(25, 118, 210, 0.22);
  --text: #263238;
  --text-muted: rgba(38, 50, 56, 0.5);
  --surface: #ffffff;
  --surface-alt: #f7fbff;
  --border: rgba(0, 0, 0, 0.07);
  --radius-sm: 10px;
  --radius-md: 16px;
  --radius-lg: 22px;
}

/* ─── FAB ───────────────────────────────────────────────── */
.lc__fab {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 12;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(145deg, var(--blue-dark), var(--blue-light));
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.32);
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s;
}
.lc__fab:hover { transform: scale(1.07); box-shadow: 0 12px 32px rgba(25, 118, 210, 0.42); }
.lc__fab:active { transform: scale(0.95); }
.lc__fab svg { width: 26px; height: 26px; position: relative; z-index: 1; }

.lc__fab-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(25, 118, 210, 0.28);
  animation: fabRing 2.6s ease-out infinite;
}
.lc__fab-ring--1 { width: 58px; height: 58px; animation-delay: 0s; }
.lc__fab-ring--2 { width: 80px; height: 80px; animation-delay: 0.8s; }
@keyframes fabRing { 0% { opacity: 0.5; transform: scale(1); } 100% { opacity: 0; transform: scale(1.4); } }

/* ─── Overlay ───────────────────────────────────────────── */
.lc__overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(30, 40, 60, 0.38);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* ─── Panel ─────────────────────────────────────────────── */
.lc__panel {
  width: 100%;
  max-width: 900px;
  height: min(760px, calc(100vh - 48px));
  border-radius: var(--radius-lg);
  background: var(--surface);
  border: 1px solid var(--blue-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(18, 38, 63, 0.18), 0 0 0 1px rgba(25, 118, 210, 0.06);
}
.lc__panel--fullscreen { max-width: 100%; height: 100vh; border-radius: 0; }

/* ─── Header ────────────────────────────────────────────── */
.lc__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #64b5f6 100%);
  flex-shrink: 0;
}
.lc__header-left { display: flex; align-items: center; gap: 12px; }

.lc__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}
.lc__avatar svg { width: 22px; height: 22px; }

.lc__header-name { font-size: 15px; font-weight: 600; color: #fff; letter-spacing: 0.01em; line-height: 1.2; }
.lc__header-status { display: flex; align-items: center; gap: 5px; font-size: 11px; color: rgba(255,255,255,0.72); margin-top: 2px; }
.lc__status-dot { width: 6px; height: 6px; border-radius: 50%; background: #69f0ae; box-shadow: 0 0 5px #69f0ae; animation: blink 2.2s ease-in-out infinite; }
@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.35; } }

.lc__header-actions { display: flex; align-items: center; gap: 4px; }

.lc__icon-btn {
  width: 34px; height: 34px;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(255,255,255,0.2);
  background: rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.85);
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
}
.lc__icon-btn svg { width: 16px; height: 16px; }
.lc__icon-btn:hover { background: rgba(255,255,255,0.2); }

/* ─── Sessions dropdown ─────────────────────────────────── */
.lc__sessions-wrap { position: relative; }
.lc__sessions-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 272px;
  background: var(--surface);
  border: 1px solid var(--blue-border-mid);
  border-radius: var(--radius-md);
  box-shadow: 0 12px 40px rgba(18,38,63,0.15);
  overflow: hidden;
  z-index: 50;
  padding: 6px;
}
.lc__session-new {
  display: flex; align-items: center; gap: 8px;
  width: 100%; padding: 9px 12px;
  border-radius: var(--radius-sm);
  border: 1px dashed var(--blue-border-mid);
  background: var(--blue-bg-soft);
  color: var(--blue);
  font-size: 13px; font-weight: 500;
  cursor: pointer; transition: background 0.15s;
}
.lc__session-new svg { width: 15px; height: 15px; flex-shrink: 0; }
.lc__session-new:hover { background: var(--blue-bg); }

.lc__sessions-list { margin-top: 6px; max-height: 220px; overflow-y: auto; }
.lc__sessions-list::-webkit-scrollbar { width: 3px; }
.lc__sessions-list::-webkit-scrollbar-thumb { background: var(--blue-border-mid); border-radius: 2px; }
.lc__session-item {
  display: flex; flex-direction: column; gap: 2px;
  width: 100%; padding: 8px 12px;
  border-radius: var(--radius-sm); border: none;
  background: transparent; cursor: pointer; text-align: left;
  transition: background 0.12s;
}
.lc__session-item:hover { background: var(--blue-bg-soft); }
.lc__session-item--active { background: var(--blue-bg); }
.lc__session-title { font-size: 13px; color: var(--text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lc__session-date { font-size: 11px; color: var(--text-muted); }

/* ─── Body ──────────────────────────────────────────────── */
.lc__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px 18px;
  background: linear-gradient(180deg, var(--blue-bg-soft) 0%, #eef5fb 100%);
}
.lc__body::-webkit-scrollbar { width: 4px; }
.lc__body::-webkit-scrollbar-thumb { background: var(--blue-border-mid); border-radius: 2px; }

/* ─── Error ─────────────────────────────────────────────── */
.lc__error {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px; margin-bottom: 14px;
  border-radius: var(--radius-sm);
  background: #fff3f3; border: 1px solid rgba(211,47,47,0.18);
  color: #c62828; font-size: 13px;
}
.lc__error svg { width: 15px; height: 15px; flex-shrink: 0; }

/* ─── Spinner ───────────────────────────────────────────── */
.lc__state { display: flex; align-items: center; justify-content: center; min-height: 200px; }
.lc__spinner { display: flex; gap: 6px; }
.lc__spinner span {
  width: 8px; height: 8px; border-radius: 50%;
  background: rgba(25, 118, 210, 0.4);
  animation: bounce 0.8s ease-in-out infinite;
}
.lc__spinner span:nth-child(2) { animation-delay: 0.15s; }
.lc__spinner span:nth-child(3) { animation-delay: 0.3s; }
@keyframes bounce { 0%, 100% { transform: translateY(0); opacity: 0.45; } 50% { transform: translateY(-7px); opacity: 1; } }

/* ─── Empty ─────────────────────────────────────────────── */
.lc__empty { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 300px; text-align: center; padding: 24px; }
.lc__empty-icon {
  width: 72px; height: 72px; border-radius: 50%;
  background: var(--blue-bg);
  border: 1px solid var(--blue-border-mid);
  display: flex; align-items: center; justify-content: center;
  color: var(--blue); margin-bottom: 16px;
  animation: float 3s ease-in-out infinite;
}
.lc__empty-icon svg { width: 36px; height: 36px; }
@keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
.lc__empty-title { font-size: 18px; font-weight: 600; color: var(--text); margin: 0 0 6px; }
.lc__empty-sub { font-size: 13px; color: var(--text-muted); margin: 0 0 20px; max-width: 260px; line-height: 1.5; }
.lc__chips { display: flex; flex-wrap: wrap; gap: 7px; justify-content: center; }
.lc__chip {
  padding: 6px 13px; border-radius: 999px;
  border: 1px solid var(--blue-border-mid);
  background: var(--surface); color: var(--blue);
  font-size: 12px; cursor: pointer; transition: all 0.15s;
}
.lc__chip:hover { background: var(--blue-bg); border-color: rgba(25,118,210,0.35); }

/* ─── Messages ──────────────────────────────────────────── */
.lc__messages { display: flex; flex-direction: column; gap: 16px; }
.lc__msg { display: flex; gap: 9px; align-items: flex-end; }
.lc__msg--user { flex-direction: row-reverse; }

.lc__msg-avatar {
  flex-shrink: 0; width: 28px; height: 28px; border-radius: 50%;
  background: linear-gradient(135deg, var(--blue-dark), var(--blue-light));
  display: flex; align-items: center; justify-content: center;
  color: white; margin-bottom: 18px;
}
.lc__msg-avatar svg { width: 15px; height: 15px; }

.lc__bubble-wrap { max-width: 72%; display: flex; flex-direction: column; }
.lc__msg--user .lc__bubble-wrap { align-items: flex-end; }
.lc__msg--ai .lc__bubble-wrap { max-width: 88%; }

.lc__bubble {
  padding: 10px 14px;
  border-radius: 18px 18px 18px 5px;
  font-size: 13.5px; line-height: 1.55; word-break: break-word;
  background: var(--surface);
  border: 1px solid var(--blue-border);
  color: var(--text);
  box-shadow: 0 2px 10px rgba(18,38,63,0.06);
}
.lc__msg--user .lc__bubble {
  border-radius: 18px 18px 5px 18px;
  background: linear-gradient(135deg, var(--blue-dark) 0%, #1e88e5 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 16px rgba(25,118,210,0.25);
}

/* Typing */
.lc__bubble--typing { display: flex; align-items: center; gap: 5px; min-height: 38px; }
.lc__bubble--typing span {
  width: 7px; height: 7px; border-radius: 50%;
  background: rgba(25,118,210,0.45);
  animation: dotPulse 1.2s ease-in-out infinite;
}
.lc__bubble--typing span:nth-child(2) { animation-delay: 0.2s; }
.lc__bubble--typing span:nth-child(3) { animation-delay: 0.4s; }
@keyframes dotPulse { 0%, 100% { transform: scale(0.7); opacity: 0.4; } 50% { transform: scale(1.1); opacity: 1; } }

/* Timestamp */
.lc__ts { font-size: 10px; color: var(--text-muted); margin-top: 4px; padding: 0 4px; }
.lc__msg--user .lc__ts { text-align: right; }

/* ─── Fundamentos ───────────────────────────────────────── */
.lc__fund { margin-top: 7px; }
.lc__fund-toggle {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 10px; border-radius: 8px;
  border: 1px solid var(--blue-border-mid);
  background: var(--blue-bg-soft);
  color: rgba(25,118,210,0.75);
  font-size: 11.5px; cursor: pointer; transition: all 0.15s;
}
.lc__fund-toggle svg { width: 12px; height: 12px; flex-shrink: 0; }
.lc__fund-toggle:hover { background: var(--blue-bg); color: var(--blue); }
.lc__chevron { transition: transform 0.2s ease; margin-left: 1px; }
.lc__chevron--open { transform: rotate(180deg); }

.lc__fund-body { margin-top: 8px; display: flex; flex-direction: column; gap: 7px; }
.lc__fund-item {
  padding: 9px 12px; border-radius: var(--radius-sm);
  background: var(--surface); border: 1px solid var(--blue-border);
}
.lc__fund-title { font-size: 12px; font-weight: 600; color: var(--text); margin-bottom: 5px; }
.lc__fund-tags { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 5px; }
.lc__tag {
  padding: 2px 8px; border-radius: 999px;
  background: var(--blue-bg); border: 1px solid var(--blue-border-mid);
  color: var(--blue-dark); font-size: 10px; font-weight: 600;
}
.lc__fund-trecho { font-size: 11.5px; color: var(--text-muted); font-style: italic; line-height: 1.5; }

/* ─── Content Blocks ────────────────────────────────────── */
.lc-block + .lc-block { margin-top: 7px; }

.lc-block__heading {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 10px; border-radius: 999px;
  background: var(--blue-bg); border: 1px solid var(--blue-border);
  color: #0d47a1; font-size: 12.5px; font-weight: 700;
}
.lc-block__heading svg { width: 12px; height: 12px; flex-shrink: 0; color: var(--blue); }

.lc-block__p { margin: 0; line-height: 1.6; }
.lc-block__sub {
  display: inline-flex; padding: 3px 10px; border-radius: 999px;
  background: #fff8e1; border: 1px solid rgba(255,179,0,0.2);
  color: #795548; font-size: 11.5px; font-weight: 700;
}
.lc-block__quote {
  margin: 0; padding: 10px 13px;
  border-left: 3px solid rgba(25,118,210,0.4); border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  background: var(--blue-bg-soft); color: #37474f;
  font-style: italic; line-height: 1.55;
}
.lc-block__legal {
  display: grid; grid-template-columns: auto 1fr; gap: 9px;
  padding: 9px 12px; border-radius: var(--radius-sm);
  background: var(--surface-alt); border: 1px solid var(--blue-border);
}
.lc-block__legal-marker {
  padding: 2px 7px; border-radius: 6px;
  background: var(--blue-bg); color: var(--blue-dark);
  font-size: 10.5px; font-weight: 700; white-space: nowrap; height: fit-content;
}
.lc-block__list {
  margin: 0; padding: 9px 12px 9px 26px;
  border-radius: var(--radius-sm);
  background: var(--surface-alt); border: 1px solid var(--blue-border);
}
.lc-block__list li { margin-bottom: 5px; line-height: 1.55; }
.lc-block__list li:last-child { margin-bottom: 0; }
.lc-block__list li::marker { color: var(--blue); }

.lc-block__table-wrap { max-width: 100%; overflow-x: auto; border-radius: var(--radius-sm); border: 1px solid var(--blue-border-mid); }
.lc-block__table { width: 100%; min-width: 520px; border-collapse: collapse; font-size: 12px; }
.lc-block__table th { padding: 9px 12px; background: var(--blue-bg); color: #0d47a1; text-align: left; font-weight: 600; border-bottom: 1px solid var(--blue-border-mid); }
.lc-block__table td { padding: 9px 12px; color: var(--text); border-top: 1px solid var(--blue-border); vertical-align: top; }
.lc-block__table tr:nth-child(even) td { background: var(--blue-bg-soft); }

.lc-b { font-weight: 700; }
.lc-i { font-style: italic; }

/* ─── Composer ──────────────────────────────────────────── */
.lc__footer {
  flex-shrink: 0;
  padding: 12px 16px 14px;
  background: var(--surface);
  border-top: 1px solid var(--border);
}
.lc__composer {
  display: flex; align-items: flex-end; gap: 10px;
  padding: 9px 10px 9px 16px;
  border-radius: 18px;
  border: 1.5px solid var(--blue-border-mid);
  background: var(--surface-alt);
  transition: border-color 0.2s, box-shadow 0.2s;
}
.lc__composer--active,
.lc__composer:focus-within {
  border-color: rgba(25,118,210,0.4);
  box-shadow: 0 0 0 3px rgba(25,118,210,0.06);
}
.lc__input {
  flex: 1 1 auto; background: transparent; border: none; outline: none;
  resize: none; color: var(--text); font-size: 13.5px; line-height: 1.5;
  max-height: 130px; overflow-y: auto; font-family: inherit;
  caret-color: var(--blue);
}
.lc__input::placeholder { color: rgba(38,50,56,0.35); }
.lc__input::-webkit-scrollbar { width: 3px; }
.lc__input::-webkit-scrollbar-thumb { background: var(--blue-border-mid); border-radius: 2px; }

.lc__send {
  width: 36px; height: 36px; flex-shrink: 0;
  border-radius: 12px; border: none;
  background: var(--blue-border);
  color: rgba(25,118,210,0.4);
  cursor: not-allowed; display: flex; align-items: center; justify-content: center;
  transition: all 0.2s cubic-bezier(0.34,1.56,0.64,1);
}
.lc__send svg { width: 15px; height: 15px; }
.lc__send--ready {
  background: linear-gradient(135deg, var(--blue-dark), var(--blue-light));
  color: white; cursor: pointer;
  box-shadow: 0 3px 12px rgba(25,118,210,0.3);
}
.lc__send--ready:hover { transform: scale(1.1); box-shadow: 0 5px 18px rgba(25,118,210,0.42); }
.lc__send--ready:active { transform: scale(0.95); }

/* ─── Transitions ───────────────────────────────────────── */
.lc-dialog-enter-active { animation: dialogIn 0.28s cubic-bezier(0.34,1.56,0.64,1); }
.lc-dialog-leave-active { animation: dialogOut 0.18s ease-in; }
@keyframes dialogIn { from { opacity: 0; transform: scale(0.95) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
@keyframes dialogOut { from { opacity: 1; } to { opacity: 0; transform: scale(0.97) translateY(6px); } }

.lc-msg-enter-active { animation: msgIn 0.22s ease-out; }
@keyframes msgIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

.lc-drop-enter-active { animation: dropIn 0.16s ease-out; }
.lc-drop-leave-active { animation: dropIn 0.12s ease-in reverse; }
@keyframes dropIn { from { opacity: 0; transform: translateY(-5px) scale(0.98); } to { opacity: 1; transform: translateY(0) scale(1); } }

.lc-expand-enter-active { animation: expandDown 0.2s ease-out; }
.lc-expand-leave-active { animation: expandDown 0.15s ease-in reverse; }
@keyframes expandDown { from { opacity: 0; transform: scaleY(0.92); transform-origin: top; } to { opacity: 1; transform: scaleY(1); } }

/* ─── Mobile ────────────────────────────────────────────── */
@media (max-width: 599px) {
  .lc__fab { left: 12px; bottom: 12px; width: 52px; height: 52px; }
  .lc__fab svg { width: 24px; height: 24px; }
  .lc__overlay { padding: 0; }
  .lc__body { padding: 14px 12px; }
  .lc__bubble-wrap { max-width: calc(100vw - 76px); }
  .lc__msg--ai .lc__bubble-wrap { max-width: calc(100vw - 64px); }
}
</style>